import React from 'react';
import PropTypes from 'prop-types';
import { unsafeHtmlDiv } from '~shared/utils/react';
import '../styles/article-text.scss';
import Button from '~shared/ui/Button/Button';
import { navigatePage } from '~spa/Utils/WrapperIntegration/Ucf';
import { useTranslation } from 'react-i18next';
import {
    I18N_EVENT_DETAILS_URL_HOMEPAGE,
    I18N_EVENT_DETAILS_URL_EVENT,
} from '~shared/components/sport-event/constants';
import {
    seoUrlInplayEvent,
    seoUrlEvent,
} from '~spa/Utils/SeoUrls.js';

import { useModal } from '~shared/components/modal-overlay/ModalContext';
import { MODAL_TYPES } from '~shared/components/modal-overlay/constants';

export const ArticleTextViewer = ({
    gtmCategory,
    text,
    subtitle,
    event_id: eventId,
    is_inplay: isInplay,
    event_slug: eventSlug,
    sport_slug: sportSlug,
    category_slug: categorySlug,
    tournament_slug: tournamentSlug,
}) => {
    const { removeModalsWithId } = useModal();
    const [ t ] = useTranslation();

    const handleClick = () => {
        const INPLAY_EVENT_URL_PATH = `${t(I18N_EVENT_DETAILS_URL_HOMEPAGE)}/${t(I18N_EVENT_DETAILS_URL_EVENT)}`;
        const baseUrl = `${sportSlug}/${categorySlug}/${tournamentSlug}`;
        const PREPLAY_EVENT_URL_PATH = `${baseUrl}/${eventSlug}`;
        let url;

        if (isInplay) {
            url = seoUrlInplayEvent(`${INPLAY_EVENT_URL_PATH}/${eventId}`, eventId);
        } else {
            url = seoUrlEvent(PREPLAY_EVENT_URL_PATH, eventId);
        }

        removeModalsWithId(MODAL_TYPES.LONG_ARTICLE);
        navigatePage(url);
    };

    return(
        <div className='article-text-container'>
            <div className='article-text'>
                <span className='article-text__subtitle'>
                    {subtitle}
                </span>
                <span>
                    {unsafeHtmlDiv(text)}
                </span>
            </div>
            {Boolean(eventId) &&
                <Button
                    isRounded
                    className='article-text__button'
                    label= {t('long_articles_widget.goto_button')}
                    onClick={() => handleClick()}
                    data-spectate-product={`${gtmCategory};longform-article;visit-event`}
                />
            }
        </div>
    );
};

ArticleTextViewer.propTypes = {
    text: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    event_id: PropTypes.number,
    category_slug: PropTypes.string,
    event_slug: PropTypes.string,
    sport_slug: PropTypes.string,
    tournament_slug: PropTypes.string,
    gtmCategory: PropTypes.string,
    is_inplay: PropTypes.number,
};

ArticleTextViewer.defaultProps = {
    event_id: null,
    category_slug: '',
    event_slug: '',
    sport_slug: '',
    tournament_slug: '',
    gtmCategory: '',
    is_inplay: 0,
};

export default ArticleTextViewer;
